export const ru = {
    'nav.today': "Обзор Сегодня",
    'nav.calendar': "Календарь Спроса",
    'nav.rates': "Тарифы и Правила",
    'nav.automation': "Автоматизация",
    'nav.audit': "Журнал Аудита",
    'nav.settings': "Настройки",
    'sidebar.status': "Подключено",
    'stat.occupancy': "Загрузка",
    'stat.adr': "ADR (Ср. цена)",
    'stat.revpar': "RevPAR",
    'stat.revenue': "Ожид. Выручка",
    'stat.trend.vsLastWeek': "vs прош. нед.",
    'stat.trend.onPace': "По плану",
    'dashboard.actions.title': "Рекомендации",
    'dashboard.actions.empty': "Нет рекомендаций.",
    'filter.all': "Все",
    'filter.pricing': "Цены",
    'filter.restriction': "Ограничения",
    'action.approve': "Принять",
    'action.reject': "Отклонить",
    'action.risk.low': "низкий риск",
    'action.risk.medium': "средний риск",
    'action.risk.high': "высокий риск",
    'action.label.current': "Тек.",
    'action.label.proposed': "Предл.",
    'action.metric.impact': "Эффект",
    'action.metric.why': "Причина",
    'action.status.executed': "Авто-Выполнено",
    'header.search': "Поиск...",
    'header.logout': "Выйти",
    'auto.level.title': "Уровень Автопилота",
    'auto.level.manual': "Ручной",
    'auto.level.manual.desc': "Вы одобряете каждую рекомендацию.",
    'auto.level.assisted': "Ассистент",
    'auto.level.assisted.desc': "Авто-одобрение низкого риска. Проверка важных изменений.",
    'auto.level.auto': "Полный Автомат",
    'auto.level.auto.desc': "ИИ управляет ценами 24/7 в ваших границах.",
    'auto.level.active': "Активен",
    'auto.guardrails.title': "Границы Безопасности",
    'auto.guardrails.maxIncrease': "Макс. Рост / День",
    'auto.guardrails.maxIncrease.desc': "Избегать скачков цен.",
    'auto.guardrails.maxDecrease': "Макс. Снижение / День",
    'auto.guardrails.maxDecrease.desc': "Избегать демпинга.",
    'auto.guardrails.minRate': "Мин. Тариф",
    'auto.guardrails.minRate.desc': "Никогда не продавать ниже этой цены (Net).",
    'auto.emergency.title': "Экстренное Управление",
    'auto.emergency.label': "Аварийная Остановка",
    'auto.emergency.desc': "Немедленно остановить всю автоматизацию.",
    'auto.emergency.btn': "ПАУЗА СИСТЕМЫ",
    'rates.filter.all': "Все типы номеров",
    'rates.filter.next14': "След. 14 дней",
    'rates.export': "Экспорт",
    'audit.table.time': "Время",
    'audit.table.actor': "Автор",
    'audit.table.category': "Категория",
    'audit.table.action': "Действие",
    'audit.table.details': "Детали",
    'audit.table.status': "Статус",
    'settings.pms.title': "Подключение PMS",
    'settings.pms.connected': "Подключено к",
    'settings.pms.disconnect': "Отключить",
    'settings.account.title': "Аккаунт",
    'settings.account.role': "Роль",
    'settings.restart': "Перезапуск Настройки",
    'onboard.title': "Подключить PMS",
    'onboard.desc': "Выберите вашу PMS для синхронизации.",
    'onboard.connecting': "Подключение...",
    'onboard.connect': "Подключить",
    'onboard.success.title': "Настройка Завершена!",
    'onboard.success.desc': "**SynthHotel Berlin** теперь синхронизирован.",
    'onboard.success.sub': "Импортировано 3 типа номеров, 14 тарифов и 243 бронирования.",
    'onboard.btn.dashboard': "К Дашборду",
    'action.dynamic.weekend.title': "Повысить Тариф на Выходные",
    'action.dynamic.weekend.desc': "Загрузка > 75% в субботу, сильный спрос (+12 номеров за 24ч).",
    'action.dynamic.minstay.title': "Вкл. Мин. Проживание 2 Ночи",
    'action.dynamic.minstay.desc': "Концерт Тейлор Свифт. Исключить 1-дневные брони.",
    'action.dynamic.distress.title': "Снизить Тариф (Слабый Спрос)",
    'action.dynamic.distress.desc': "Загрузка 35% во вторник. Конкуренты снизили на €10.",
    'action.dynamic.gap.title': "Закрыть Окно: Снять CTA",
    'action.dynamic.gap.desc': "Одиночная ночь. Снять 'Закрыто на заезд' для продажи.",
};
